var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our_partners"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Our Partners")]),_vm._v(" "),_c('div',{staticClass:"partners"},_vm._l((_vm.partners),function(item){return _c('div',{staticClass:"partners__item"},[_c('img',{attrs:{"src":item.url}})])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aebafdd4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page/Client/partners.vue
// module id = null
// module chunks = 